import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, map, BehaviorSubject } from 'rxjs';
import { User } from 'src/app/model//user';
import { environment } from 'src/environments/environment';
import { RsaEncryptionService } from './rsa-encryption.service';
import { AesEncryptionService } from './aes-encryption.service';

@UntilDestroy()
@Injectable()
export class AuthorizationService {

  private userSubject: BehaviorSubject<User | null>;
  public user: Observable<User | null>;
  url: string;
  aesKeyValue = environment.randomKey;

  constructor(private http: HttpClient, private router: Router, private _rsa: RsaEncryptionService, private _aes: AesEncryptionService) {
    this.url = environment.baseUrl;
    this.userSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('user')));
    this.user = this.userSubject.asObservable();
  }

login(user: User) {
    localStorage.clear(); //clearing any existing info
    sessionStorage.clear()

    const key = this._rsa.encryptWithPublicKey(this.aesKeyValue);
    const payload = this._aes.encrypt(user, this.aesKeyValue);
    const payloadObj = {
      payload, key
    }

    return this.http.post<User>(this.url + '/login', payloadObj)
      .pipe(
        untilDestroyed(this),
        map((res) => {
          const key = environment.randomKey;
          const encryptedData = res['data'].data.MainData;
          const user = this._aes.decrypt(encryptedData, key);
          // console.log(user)
          localStorage.setItem('access', JSON.stringify(user.UserDetails['AccessFms']));
          localStorage.setItem('IdToken', user.AuthenticationResult?.IdToken);
          localStorage.setItem('EmailAddress', user.UserDetails?.EmailAddress);
          const data = user.UserDetails;
          localStorage.setItem('FMSUserDetails', JSON.stringify(data));
          this.userSubject.next(user);
          return user;
        }),
      );
  }

  public isAuthenticated(): boolean {
    const provideAccess = localStorage.getItem('access')
    if (provideAccess == '1') {
      localStorage.setItem('fmsUserLoggedIn', 'true');
      return true;
    } else {
      return false;
    }
  }

  forgotPass(userEmail) {
    return this.http.post<any>(this.url + '/login/forgot-password', userEmail);
  }

  verifyUser(userInfo) {
    return this.http.post<any>(this.url + '/login/reset-password', userInfo);
  }

    logout() {
      localStorage.clear();
      sessionStorage.clear()
      this.router.navigateByUrl('/login'); 
    }
}
